<a mat-list-item class="mat-typography" (click)="onClick()" *ngIf="cart">
  <p mat-line>
    <small>Vuoi realizzare tu questo itinerario?</small>
  </p>
  <h4 mat-line>
    <b>{{ cart.destination }}</b>
  </h4>
  <span fxFlex></span>
  <p class="cart-details">
    <small class="cart-ndays"
      ><b>{{ cart.nDays }}</b> giorni</small
    >
    <small class="cart-plan">{{ cart.plan | uppercase }}</small>
  </p>
  <p class="cart-total">
    <span style="font-size: 12px">compensi</span><br /><b
      [ngClass]="{ striked: proposal.test }"
      >{{ proposal.fee | number: "1.2-2" }} €</b
    >
  </p>
  <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
  <button class="proposal-button" mat-raised-button color="primary">
    Accetta
  </button>
  <span>&nbsp;</span>
  <button class="proposal-button" mat-raised-button color="warn">
    Rifiuta
  </button>
</a>
